import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListIssuedAtCell } from './emsp-bo-invoice-list-issued-at.cell';
import { EmspBoInvoiceListIssuedAtHeader } from './emsp-bo-invoice-list-issued-at.header';

export const EmspBoInvoiceListIssuedAtColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['issuedAt']
> = {
  enableSorting: false,
  header: EmspBoInvoiceListIssuedAtHeader,
  cell: EmspBoInvoiceListIssuedAtCell,
};
